interface ButtonProps {
  text: string;
  onClick: () => void;
  primary?: boolean;
}

export const Button = ({ onClick, primary = true, text }: ButtonProps) => {
  return (
    <button
      className={`w-full sm:w-auto px-8 py-3 font-medium rounded-xl transition-all duration-300 shadow-sm backdrop-blur-sm ${
        primary
          ? "bg-violet-500 text-white border border-transparent hover:bg-violet-600 hover:-translate-y-0.5 active:translate-y-0 shadow-[0_0_15px_rgba(139,92,246,0.3)]"
          : "bg-transparent text-white border border-violet-500 hover:bg-violet-500/10 hover:border-violet-400 hover:-translate-y-0.5 active:translate-y-0"
      }`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};
